import styled from "styled-components";
import {
  isHtmlBlogContent,
  plainTextParagraphs,
  sanitizeBlogHtml,
} from "../../utils/blogContent";

const Prose = styled.article`
  font-size: clamp(0.9375rem, 0.88rem + 0.2vw, 1.0625rem);
  line-height: 1.75;
  color: hsl(${({ theme }) => theme.colors.foreground});

  p {
    margin: 0 0 1rem;
  }
  h2,
  h3 {
    margin: 1.5rem 0 0.75rem;
    font-weight: 700;
    line-height: 1.3;
  }
  h2 {
    font-size: 1.35rem;
  }
  h3 {
    font-size: 1.15rem;
  }
  ul,
  ol {
    margin: 0 0 1rem 1.25rem;
    padding: 0;
  }
  li {
    margin-bottom: 0.35rem;
  }
  a {
    color: hsl(${({ theme }) => theme.colors.primary});
    text-decoration: underline;
  }
`;

export default function BlogArticleBody({ content }) {
  const body = String(content || "").trim();

  if (isHtmlBlogContent(body)) {
    return (
      <Prose
        dangerouslySetInnerHTML={{ __html: sanitizeBlogHtml(body) }}
      />
    );
  }

  const paragraphs = plainTextParagraphs(body);

  return (
    <Prose>
      {paragraphs.map((para) => (
        <p key={para.slice(0, 48)}>{para}</p>
      ))}
    </Prose>
  );
}
